import styled from 'styled-components';
import { Fab } from '@mui/material'
import { deviceSizes } from '../../../../config/devices';


export const SliderContainer = styled.div`
  padding: 0 4rem;
  width: 100%;
  border-radius: 6px;
  position: relative;
  @media (max-width: ${deviceSizes.mobileL}) {
    padding-top: 2rem;
  }
  .react-multi-carousel-list {
    position: static;
  }

  .react-multi-carousel-item {
    margin: 10px;
    width: 180px !important;
    img {
      border-radius: 6px;
    }
  }
  .active {
    border: 2px solid ${({ theme }) => theme.primary.main};
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.14))
      drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.12)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.2));
  }
`;

export const VideoContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
  .eXBcJb{
    padding: 0;
    margin: 0;
    display: block;
    iframe{
      width: 100%;
      height: 350px;
    }
  }
`;

export const StyledLeftButton = styled(Fab)`
  && {
    position: absolute;
    left: 0;
    background-color: white;
    box-shadow: none;
  }
`;
export const StyledRightButton = styled(Fab)`
  && {
    position: absolute;
    right: 0;
    background-color: white;
    box-shadow: none;
  }
`;
